import apiClient from '@/services/axios'

export async function patch(bookingId, bookingState) {
  var bookingStateRequest = {
    "bookingState": bookingState
  }

  var response = await apiClient.patch(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/bookings/' + bookingId + '/booking-state', bookingStateRequest);

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to patch booking state.')
}
